/**
 * colors.ts — shared colour→swatch mapping, used by the charm colour facet
 * (filters.ts) and the bead-palette colour chips (ui.ts). One source of truth so
 * both render identical swatches.
 */

/** Label → CSS colour for the swatch dot. Keys are lowercase. */
export const COLOR_HEX: Record<string, string> = {
  pink: '#F4C2D7', red: '#D11E1E', orange: '#E8843C', yellow: '#FFCA22', green: '#3FA34D',
  blue: '#5B9BD5', purple: '#B57BD6', black: '#232323', white: '#FFFFFF', silver: '#C0C0C0',
  gold: '#C9A84C', brown: '#8B5A2B',
};

/** Inline style for a colour swatch. "multi"/"multicolour" → the rainbow conic gradient. */
export const colorStyle = (name: string): string => {
  const k = name.toLowerCase().trim();
  if (k === 'multi' || k === 'multicolour' || k === 'multicolor') {
    return 'background:conic-gradient(from 0deg,#e2452b,#e8843c,#ffca22,#3fa34d,#5b9bd5,#b57bd6,#e2452b)';
  }
  return `background-color:${COLOR_HEX[k] || name.toLowerCase()}`;
};
